"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mallShoppingCart = void 0;

var _httpRequest2 = _interopRequireDefault(require("../httpRequest"));

var _env = require("../env");

var _IGC_JS2Native = require("../IGC_JS2Native");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

// 请求头信息
var _headers = {
  'Content-Type': 'application/json;charset=UTF-8'
}; // 将添加到购物车个的商品id缓存到本地, 跳到购物车页面时商品是选中状态

function _addGoodsIdToLocal(val) {
  var localName = 'shoppingCartActive' + _headers['App-User-Pid'];
  var shoppingCartActive = JSON.parse(localStorage.getItem(localName) || '[]');

  if (Array.isArray(shoppingCartActive)) {
    shoppingCartActive = [].concat(_toConsumableArray(shoppingCartActive), _toConsumableArray(val));
    localStorage.setItem(localName, JSON.stringify(shoppingCartActive));
  }
} // 发送网络请举


function _httpRequest(_ref) {
  var url = _ref.url,
      _ref$type = _ref.type,
      type = _ref$type === void 0 ? 'post' : _ref$type,
      _ref$data = _ref.data,
      data = _ref$data === void 0 ? {} : _ref$data,
      resolve = _ref.resolve,
      reject = _ref.reject;

  _httpRequest2["default"].request(url, data, {
    timeout: 7000,
    headers: _headers,
    forceAjax: true,
    method: type
  }).then(function (res) {
    if (res && res.code === 10000) {
      // 如果是添加购物车，则将商品id缓存
      url.includes('addShoppingTrolley') && _addGoodsIdToLocal(res.data);
    }

    resolve && resolve(res);
  })["catch"](function (err) {
    reject && reject(err);
  });
} // 获取用户信息


function _getUid() {
  return new Promise(function (resolve, reject) {
    // h5环境获取用户信息
    if (!_env.env.isApp) {
      var userInfo = JSON.parse(localStorage.getItem('IGetCool-USER-Info')) || {};
      userInfo.uid ? resolve(userInfo) : reject({
        code: 8000,
        msg: '未登陆'
      });
      return;
    } // app中获取用户信息


    (0, _IGC_JS2Native.JS2Native)({
      name: 'getAppUserPid'
    }).then(function (_ref2) {
      var data = _ref2.data;

      if (data) {
        var uid = data;
        (0, _IGC_JS2Native.JS2Native)({
          name: 'getUserInfo'
        }).then(function (_ref3) {
          var data = _ref3.data;
          var userInfo = {};
          userInfo['App-Device-Key'] = data['App-Device-Key'];
          userInfo['App-Device-Type'] = data['App-Device-Type'];
          userInfo['APP-Agent'] = data['App-Version'];
          userInfo['App-Sign'] = data['App-Token'];
          userInfo['uid'] = uid;
          resolve(userInfo);
        });
      } else {
        reject({
          code: 8000,
          msg: '未登陆'
        });
      }
    })["catch"](function (err) {
      reject(err);
    });
  });
} // 配置网络请求信息


function _request(_ref4) {
  var url = _ref4.url,
      type = _ref4.type,
      data = _ref4.data;
  return new Promise(function (resolve, reject) {
    _getUid().then(function (res) {
      var userInfo = res;

      if (_env.env.isApp) {
        _headers['Shop-PutType'] = 2;
        _headers['App-Device-Key'] = userInfo['App-Device-Key'];
        _headers['App-Device-Type'] = userInfo['App-Device-Type'];
        _headers['APP-Agent'] = userInfo['APP-Agent'];
        _headers['App-Sign'] = userInfo['App-Sign'];
        _headers['App-User-Pid'] = userInfo['uid'];
      } else {
        _headers['Shop-PutType'] = 1;
        _headers['App-User-Pid'] = userInfo.uid;
        _headers['Shop-Authorization'] = userInfo.token;
      }

      _httpRequest({
        url: url,
        type: type,
        data: data,
        resolve: resolve,
        reject: reject
      });
    })["catch"](function (err) {
      err.code ? resolve(err) : reject(err);
    });
  });
}

var mallShoppingCart = {
  /**
   * 加入购物车
   * @param {Array} data
   * @returns
   */
  add: function add(data) {
    return _request({
      url: '/mall-server/api/shop/trolley/addShoppingTrolley',
      type: 'post',
      data: data || []
    });
  },

  /**
   * 获取购物车数量
   * @returns
   */
  getShopNum: function getShopNum() {
    return _request({
      url: '/mall-server/api/shop/trolley/getTrolleyCount',
      type: 'get'
    });
  }
};
exports.mallShoppingCart = mallShoppingCart;